<template>
    <div class="container">

        <header class="container__header">

            <h1>Rabatkuponer</h1>

            <router-link class="btn btn--md btn--primary primary--copper margin-t-50" :to="{name:'coupon.create'}">Tilføj ny rabatkupon</router-link>

        </header>

        <div class="container__body container__body--md">

            <header class="col-12 flex--space padding-b-25 border-b">

                <h1>Oversigt</h1>

                <div class="select-sm">

                    <ws-select :options="choices" v-model="chosenOption"></ws-select>

                </div>

            </header>

            <section class="data-list">

                <transition-group name="fade" tag="div">

                    <div class="item" v-for="coupon in couponsFiltered" :key="coupon.id">

                        <div class="icon">

                            <i class="icon--lg fas fa-shopping-bag"></i>

                        </div>

                        <div class="content">

                            <h1 v-text="coupon.title"></h1>

                            <ul>

                                <li v-if="coupon.deleted_at === null">Status: Aktiv</li>
                                <li v-else>Status: Inaktiv</li>
                                <li>Kode: {{coupon.code}}</li>
                                <!--<li>Kategori: {{product.category_title}}</li>
                                <li>Pris: {{stripeAmount(product.price).amount}},-</li>-->

                            </ul>

                        </div>

                        <div class="link">

                            <router-link :to="{name:'coupon.stats', params:{coupon:coupon.id}}">Administrer</router-link>

                        </div>

                    </div>

                </transition-group>

            </section>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "coupon-index",
        data(){
            return {
                text:'',
                chosenOption:0,
                choices:[
                    'Aktive kuponer',
                    'Slettede kuponer',
                ]
            }
        },
        computed:{
            ...mapGetters(['coupons']),
            active(){
                return (this.chosenOption === 0) ? true:false;
            },
            couponsFiltered(){
                return this.coupons.filter(item=>{
                    if(this.active){
                        return item.deleted_at === null
                    }

                    return item.deleted_at !== null;
                })
            }
        },
        created(){
            this.$store.dispatch('getCoupons');
        }
    }
</script>

<style scoped>

</style>
